import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className={`relative overflow-hidden ${isLarge ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            {comic.category}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          {comic.status === '连载中' && (
            <span className="inline-block px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
              连载
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-white text-xs font-medium flex items-center gap-1">
            <i className="ri-star-fill text-accent-400 text-[10px]"></i>
            {comic.rating}
            <span className="ml-2 opacity-70">{comic.totalChapters}话</span>
          </p>
        </div>
      </div>

      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.genres.slice(0, 2).map((genre) => (
            <span key={genre} className="px-1.5 py-0.5 bg-secondary-50 text-secondary-700 text-[10px] rounded">
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}